// extracted by mini-css-extract-plugin
export var blockBtn = "courseProgram-module--block-btn--1f2ee";
export var courseProgram = "courseProgram-module--course-program--87bf5";
export var courseProgram__description = "courseProgram-module--course-program__description--eaecf";
export var courseProgram__logo = "courseProgram-module--course-program__logo--77623";
export var courseProgram__mark = "courseProgram-module--course-program__mark--b2e68";
export var courseProgram__text = "courseProgram-module--course-program__text--1d95c";
export var courseProgram__textOne = "courseProgram-module--course-program__text--one--c9111";
export var courseProgram__textTwo = "courseProgram-module--course-program__text--two--aeba6";
export var courseProgram__title = "courseProgram-module--course-program__title--82917";
export var courseProgram__wrapper = "courseProgram-module--course-program__wrapper--5e200";
export var mainBtn = "courseProgram-module--main-btn--d82ee";
export var mainTitle = "courseProgram-module--main-title--d351f";